module.exports = __webpack_public_path__ + "static/media/icon-upload-warning.00214d70.svg";